import { createFileRoute } from '@tanstack/react-router'

import { validateShipmentListSearch } from '#/entities/shipment'
import { OrgScopePage } from '#/modules/org-scope/org-scope-page'
import { TaskPage } from '#/pages/task'

export const Route = createFileRoute('/_shell/tasks')({
  component: TasksProductPage,
  validateSearch: validateShipmentListSearch,
})

function TasksProductPage() {
  return (
    <OrgScopePage>
      {(orgId) => (
        <TaskPage key={orgId} />
      )}
    </OrgScopePage>
  )
}
